import { Scrollbar } from 'react-scrollbars-custom';
import Modal from './Modal';
import Sidebar from './Sidebar';

const ScrollContainer = ({ children, ...props }) => {
	return (
		<Scrollbar
			{...props}
            wrapperProps={{
                renderer: (innerProps) => {
					const { elementRef, style, ...restProps } = innerProps;
					const customStyle = {
						inset: '0 .17rem 0 0'
					};

					return <div style={{ ...style, ...customStyle }} {...restProps} ref={elementRef} />;
				},
            }}
			trackYProps={{
				renderer: (innerProps) => {
					const { elementRef, style, ...restProps } = innerProps;
					const customStyle = {
						width: '.17rem',
                        background: `linear-gradient(to right, rgba(0,0,0,0) 20% , #131313 21%, #131313 79%, rgba(0,0,0,0) 80%)`,
						borderRadius: '1rem',
						top: '0px',
						height: `100%`,
					};

					return <div style={{ ...style, ...customStyle }} {...restProps} ref={elementRef} className='trackY' />;
				},
			}}
			thumbYProps={{
				renderer: (innerProps) => {
					const { elementRef, style, ...restProps } = innerProps;
					const customStyle = {
						width: '.17rem',
						background: `#BE101D`,
						borderRadius: '.075rem',
					};
					return <div style={{ ...style, ...customStyle }} {...restProps} ref={elementRef} className='thumbY' />;
				},
			}}
		>
			{children}
		</Scrollbar>
	);
};

export { ScrollContainer, Modal, Sidebar };